<div
  class="select-orders-container"
  fxFlex="100"
  fxLayout="row"
  fxLayout.lt-md="column"
  *ngIf="orders"
  fxLayoutAlign="space-between start"
>
  <div
    id="cart-items"
    fxFlex="70"
    fxFlex.lt-md="100"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
  >
    <mat-checkbox fxFlex="100">انتخاب همه</mat-checkbox>

    <app-selectable-order-container
      *ngIf="orders.length > 0"
      [orders]="orders"
    ></app-selectable-order-container>
    <div class="empty-placeholder" *ngIf="orders.length <= 0">
      <h1 class="disabled" style="text-align">هیچ موردی پیدا نشد</h1>
      <img src="../../../../../assets/image/empty-box-2.svg" alt="" />
    </div>
  </div>

  <shopping-cart-payment-status
    [status]="generateStatus()"
    (submit)="this.submit()"
    fxFlex="28"
    fxFlex.lt-md="100"
  ></shopping-cart-payment-status>
</div>
